import React, { Component } from 'react';
import './App.css';
import { routes } from './constants';
import LandingContainer from './containers/landing';
import FolioContainer from './containers/folio/folio';
import InsideContainer from './containers/inside-chevo/inside';
import ProcessContainer from './containers/how-we-work/process';
import LoginContainer from './containers/login/login';
import AddContainer from './containers/add/add';
import AdminContainer from './containers/admin/admin';
import ContentContainer from './containers/content/content';
import OtherContainer from './containers/other';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom'
import Header from './components/Header/Header';
import { firebaseConnect } from 'react-redux-firebase';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import * as folioActions from "./actions/folio-actions";
import { ThemeProvider } from 'styled-components';
import classnames from 'classnames';
import styled from 'styled-components';

class App extends Component {

  render() {
    const isMobile = (/Mobile|Android|BlackBerry/.test(navigator.userAgent));
    const theme = {

      colors: {
        background: '#333333',
        primary: '#ab3029',
        secondary: '#f9e7cc',
      },
      fonts: {
        small: {
          fontSize: '16px',
          lineHeight: '18px',
          mobileFontSize: '16px',
          mobileLineHeight: '20px',
        },
        medium: {
          fontSize: '26px',
          lineHeight: '40px',
          mobileFontSize: '16px',
          mobileLineHeight: '20px',
        },
        large: {
          fontSize: '28px',
          lineHeight: '40px',
          mobileFontSize: '22px',
          mobileLineHeight: '30px',
        },
        xLarge: {
          fontSize: '36px',
          lineHeight: '40px',
          mobileFontSize: '24px',
          mobileLineHeight: '26px',
        }
      }
    };

    const wrapperStyles = {
      'is-mobile': isMobile,
      'wrapper--outer': true,
      'is-folio': this.props.location &&
          this.props.location.pathname.includes('folio') &&
          this.props.location.pathname !== '/folio'
    };

    const Lost = styled.div`
    color: #f9e7cc;
    margin-top: 300px;
    padding: 0 50px
`;

    const lost = () => <Lost>Lost? The page you navigated to does not exists.</Lost>;

    return (
        <ThemeProvider theme={ theme }>
          <div className={ classnames(wrapperStyles) }>
            <Header deviceType={ isMobile ? 'mobile' : 'desktop' }
                    username={ this.props.auth.displayName }
                    logout={ () => { this.props.firebase.logout(); this.props.history.push(routes.HOME) } }
            />
            <Switch>
              <Route exact path={ routes.HOME } component={ LandingContainer } />
              <Route exact path={ routes.LOGIN } component={ LoginContainer } />
              {/*<Route exact path={ `${ routes.ADMIN }/stories/:id` } render={(props) => <ContentContainer { ...props }/> } />*/}
              <Route path={ `${ routes.ADMIN }` } component={ AdminContainer } />
              <Route exact path={ `${ routes.ABOUT }` } render={(props) => <Redirect to="about/andy-dufford" /> } />
              <Route exact path={ `${ routes.ABOUT }/:name` } render={(props) => <InsideContainer {...props} section="about" /> } />
              <Route exact path={ `${ routes.PROCESS }` } render={(props) => <Redirect to="process/artful-spaces" /> } />
              <Route exact path={ `${ routes.PROCESS }/:path` } render={(props) => <ProcessContainer {...props} section="process" /> } />
              <Route exact path={ `${ routes.FOLIO }/:title?` } component={ FolioContainer } />
              <Route path={ `${ routes.ADD_PROJECT }/:id?` } component={ AddContainer } />
              <Route render={(props) => <OtherContainer {...props} section="other" /> } />
            </Switch>
            <div className="bottom-rail"/>
          </div>
        </ThemeProvider>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(folioActions, dispatch)
  }
}


export default withRouter(compose(
    firebaseConnect(['projects']),
    connect(( state ) => { return ({
      projects: state.firebase.data.projects,
      folio: state.folio,
      inside: state.inside,
      auth: state.firebase.auth
    }) }, mapDispatchToProps()
    )
)(App))



// WEBPACK FOOTER //
// ./src/App.js